import React from 'react';
import { useNavigate } from 'react-router-dom';
import { generateArticleUrl } from '../../utils/urlHelper';

const NewsCard = ({ article }) => {
    const navigate = useNavigate();

    const getTagColor = (category) => {
        const colors = {
            Politics: 'blue',
            Sports: 'green',
            Business: 'orange',
            Technology: 'blue',
            World: 'blue'
        };
        return colors[category] || '';
    };

    return (
        <div className="news-card" onClick={() => navigate(generateArticleUrl(article))}>
            <img src={article.img || article.imgData || 'https://via.placeholder.com/400x200'} alt="" onError={(e) => e.target.src = 'https://via.placeholder.com/400x200'} />
            <div className="body">
                <span className={`tag ${getTagColor(article.category)}`}>{article.category}</span>
                <h4>{article.title}</h4>
                <div className="meta">✍️ {article.author} · 📅 {article.date}</div>
                <div className="excerpt">{article.excerpt?.substring(0, 120)}...</div>
            </div>
        </div>
    );
};

export default NewsCard;